import { motion } from 'framer-motion';
import SectionLabel from './SectionLabel';
import { fadeUp, stagger } from '../../motion/variants';

const SectionHeader = ({
  label,
  title,
  titleLine1,
  titleLine2,
  titleAccent,
  subtitle,
  align = 'left',
  className = '',
  children,
}) => {
  const alignClass = align === 'center' ? 'text-center mx-auto' : '';
  const accentClass = titleAccent === 'muted' ? 'text-white/45' : 'text-white';

  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: '-72px' }}
      variants={stagger}
      className={`max-w-3xl mb-14 sm:mb-16 ${alignClass} ${className}`}
    >
      <motion.div variants={fadeUp}>
        <SectionLabel>{label}</SectionLabel>
      </motion.div>
      <motion.h2
        variants={fadeUp}
        className="text-[1.75rem] sm:text-4xl lg:text-[2.75rem] font-semibold tracking-[-0.03em] leading-[1.08] text-white mb-4"
      >
        {titleLine1 ? (
          <>
            <span className={accentClass}>{titleLine1}</span>
            {titleLine2 && (
              <>
                <br />
                <span className="text-white/45">{titleLine2}</span>
              </>
            )}
          </>
        ) : (
          title
        )}
      </motion.h2>
      {subtitle && (
        <motion.p variants={fadeUp} className="text-base sm:text-lg text-white/40 leading-relaxed">
          {subtitle}
        </motion.p>
      )}
      {children && <motion.div variants={fadeUp}>{children}</motion.div>}
    </motion.div>
  );
};

export default SectionHeader;